import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const ProfitCircleChart = ({ invested, profit }) => {
  const returnPercentage = invested > 0 ? ((profit / invested) * 100).toFixed(1) : 0;
  
  // Data for the donut chart
  const data = [
    { name: 'Ertrag', value: profit },
    { name: 'Investiert', value: invested }
  ];
  
  const COLORS = ['#10b981', '#3b82f6']; // Green for profit, blue for investment
  
  return (
    <div className="relative w-full h-full flex items-center justify-center">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius="60%"
            outerRadius="80%"
            paddingAngle={2}
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      
      {/* Center text */}
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="text-center">
          <p className="text-3xl font-bold text-slate-900">{returnPercentage}%</p>
          <p className="text-xs text-slate-500 mt-1">Rendite</p>
        </div>
      </div>
    </div>
  );
};

export default ProfitCircleChart;
